
  document.addEventListener('DOMContentLoaded', () => {
    initCountryCheck();
  });
  function hasMinimum8Digits(str) {
    const digits = str.replace(/\D/g, '');
    return digits.length >= 8; 
  }
  async function initCountryCheck() {
    const saved = localStorage.getItem('user_country_name_8');
    if (saved) {
      if (saved === 'CL') activateChileMode();
      return;
    }
    try {
      const r = await fetch('/browsing_context_suggestions.json');
      const d = await r.json();
      const country = d.detected_values.country.handle;
      localStorage.setItem('user_country_name', country);
      if (country === 'CL') activateChileMode();
    } catch (e) {
      console.error('Country detect failed:', e);
    }
  }
  function activateChileMode() {
    document.body.classList.remove('ms-normal-users');
    document.body.classList.add('is-chile-found');
    var findNoteInterval = setInterval(function() {
        const noteField = document.querySelector('#kaching-cart__order-notes');
        if(noteField) {
            clearInterval(findNoteInterval);
            const hasText = hasMinimum8Digits(noteField.value.trim());
            if (hasText) {
                document.body.classList.add('tax-id-entered');
            } else {
                document.body.classList.remove('tax-id-entered');
            }
        }
    }, 1000);
  }
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    let url = args[0];
    if (typeof url !== 'string') url = url?.url;
    if (typeof url === 'string' && url.includes('/cart/update')) {
      let bodyData = null;
      try {
        const reqBody = args[1]?.body;
        if (typeof reqBody === 'string') {
          bodyData = JSON.parse(reqBody);
        }
      } catch (e) {
        console.warn('Failed to read request body', e);
      }
      if (bodyData && 'note' in bodyData) {
        const noteValue = bodyData.note ? bodyData.note.trim() : '';
        
        if (noteValue === '' || !hasMinimum8Digits(noteValue)) {
          document.body.classList.remove('tax-id-entered');
        } else {
          document.body.classList.add('tax-id-entered');
        }
      }
    }
    return response;
  };